import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api/apiClient';

export interface WaivedPlayerFilters {
  nameLike?: string;
  positions?: string[];
  salaryMin?: string;
  salaryMax?: string;
  year?: number;
  lastTeam?: string;
  statuses?: string[];
}

export interface UseWaivedPlayersOptions {
  leagueId: number;
  filters?: WaivedPlayerFilters;
  page?: number;
  pageSize?: number;
}

export function useWaivedPlayers({ leagueId, filters = {}, page = 0, pageSize = 50 }: UseWaivedPlayersOptions) {
  const [currentFilters, setCurrentFilters] = useState<WaivedPlayerFilters>(filters);
  const [currentPage, setCurrentPage] = useState(page);
  const [currentPageSize, setCurrentPageSize] = useState(pageSize);

  const queryKey = ['waivedPlayers', leagueId, currentFilters, currentPage, currentPageSize];

  const { data, isLoading, error, refetch, isFetching } = useQuery({
    queryKey,
    queryFn: async () => {
      const params: Record<string, unknown> = {
        ...currentFilters,
        page: currentPage,
        pageSize: currentPageSize,
      };
      // Note: Position filtering is now handled on the frontend
      // Note: Status filtering is now handled on the frontend
      // Remove empty filters
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '' || params[key] === null) {
          delete params[key];
        }
      });
      const res = await apiClient.get(`/roster/waiver-wire/${leagueId}`, { params });
      return res.data;
    },
    enabled: !!leagueId,
  });

  // For infinite scroll, you could use useInfiniteQuery instead

  return {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    setFilters: setCurrentFilters,
    setPage: setCurrentPage,
    setPageSize: setCurrentPageSize,
    filters: currentFilters,
    page: currentPage,
    pageSize: currentPageSize,
  };
} 